/*
 *		Copyright (c) 2011-2014 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

'use strict';

angular.module('accessWebClient')
    .controller('MultiResultsModalController', ['$scope', '$modalInstance', 'multiResults', 'constructor', 'action', '$timeout', '$translate', 'flashMessagesService',
        function($scope, $modalInstance, multiResults, constructor, action, $timeout, $translate, flashMessagesService) {
            var MODAL_TTL = 1800,
                CONFLICT_ERROR_CODE = 409,
                parentConflict = false;

            $scope.modal = $modalInstance.options;
            $scope.multiResults = multiResults;
            $scope.action = action;
            $scope.actionMap = {
                copy: {
                    template: 'transfer',
                    errorMessage: ['%{count} item was not copied, because it already exists in the destination.', '%{count} items were not copied, because they already exist in the destination.'],
                    successMessage: ['%{count} item was copied.', '%{count} items were copied.']
                },
                move: {
                    template: 'transfer',
                    errorMessage: ['%{count} item was not moved, because it already exists in the destination.', "%{count} items were not moved, because they already exist in the destination."],
                    successMessage: ['%{count} item was moved.', '%{count} items were moved.']
                },
                restore: {
                    template: 'restore',
                    errorMessage: ['%{count} item was not restored, because it already exists in the destination.', '%{count} items were not restored, because they already exist in the destination.'],
                    successMessage: ['%{count} item was restored.', '%{count} items were restored.']
                },
                notarize: {
                    template: 'default',
                    errorMessage: ['node_notarization_multi_results_error_text', 'node_notarization_multi_results_error_text'],
                    successMessage: ['node_notarization_multi_results_success_message_singular', 'node_notarization_multi_results_success_message_plural']
                },
                delete: {
                    template: 'default',
                    errorMessage: ['%{count} item was not deleted.', '%{count} items were not deleted.'],
                    successMessage: ['%{count} item was deleted.', '%{count} items were deleted.']
                },
                unsubscribe: {
                    template: 'default',
                    errorMessage: ['%{count} item was not unsubscribed.', '%{count} items were not unsubscribed.'],
                    successMessage: ['%{count} item was unsubscribed.', '%{count} items were unsubscribed.']
                },
                unsubscribeDelete: {
                    template: 'default',
                    errorMessage: ['%{count} item was not unsubscribed or deleted.', '%{count} items were not unsubscribed or deleted.'],
                    successMessage: ['%{count} item was unsubscribed or deleted.', '%{count} items were unsubscribed or deleted.']
                },
                revokeAll: {
                    template: 'default',
                    errorMessage: ['%{count} item did not have its links removed.', '%{count} items did not have their links revoked.'],
                    successMessage: ['%{count} item did have its links removed.', '%{count} items did have their links revoked.']
                }
            };

            $scope.passedCount = $scope.failedCount = 0;

            $scope.ok = $scope.close = function () {
                if (succeededCount() > 0) {
                    flashMessagesService.add($scope.message('success', succeededCount()), flashMessagesService.SUCCESS);
                }
                $modalInstance.close($scope.multiResults);
            };

            $scope.message = function (type, count) {
                return $translate.instant(untranslatedMessage(type, count), {count: count});
            };

            $scope.modal.loading = true;

            angular.forEach(multiResults, function (result) {
                result.promise().catch(function (response) {
                    $scope.failedCount++;

                    if (response.status === CONFLICT_ERROR_CODE && action === 'restore') {
                        var conflictNode = response.data.error.context.conflict;

                        if (response.config.data.uuid !== conflictNode.uuid) {
                            parentConflict = true;
                        }
                        result.uuid = response.config.data.uuid;
                        result.rename_uuid = conflictNode.uuid; // could be the parent folder that triggers the conflict
                        result.rename_to = conflictNode.name;
                        result.is_directory = conflictNode.is_directory; // if the parent folder then we update the icon
                        result.retryRestore = _retryRestore;
                        result.conflictRestore = true;
                    } else if (response.status === CONFLICT_ERROR_CODE) { // move or copy
                        result.uuid = response.config.data.uuid;
                        result.destination = response.config.data.parent_uuid;
                        result.nodeOverwrite = _nodeOverwrite.bind(result);
                        result.conflictTransfer = true;
                    } else {
                        result.errorMessage = response.data.error.message;
                        result.failed = true;
                    }

                    flashMessagesService.add($scope.message('error', $scope.failedCount), flashMessagesService.ERROR);
                }).finally(function() {
                    result.ready = true;
                    $scope.passedCount++; // cannot use $q.all because it fires on the first fail
                    if ($scope.passedCount == multiResults.length) {
                        $scope.modal.loading = false;
                        if ($scope.failedCount == 0) scheduleClose();
                    }
                });
            });

            function _nodeOverwrite() {
                var result = this;
                result.ready = false;
                constructor[action]({
                    uuid: result.uuid,
                    parent_uuid: result.destination,
                    conflict_override: true
                }).$promise.then(function () {
                    result.conflictResolved = true;
                    $scope.failedCount--;
                }).catch(function (response) {
                    result.errorMessage = response.data.error.message;
                    result.failed = true;
                }).finally(function () {
                    result.ready = true;
                    result.conflictTransfer = false;
                    if ($scope.failedCount == 0) scheduleClose();
                });
            }

            function _retryRestore() {
                (function(result){
                    if (!result.ready) return;
                    result.conflictRestore = false;
                    result.ready = false;
                    result.name = result.rename_to;
                    constructor[action](result).$promise.then(function(result){
                        $scope.failedCount--;
                        if (parentConflict) {
                            _retryRestoreOnConflicted();
                        }
                    }).catch(function(response){
                        if (response.status === CONFLICT_ERROR_CODE) {
                            result.conflictRestore = true;
                        } else {
                            result.errorMessage = response.data.error.message;
                            result.failed = true;
                        }
                    }).finally(function(){
                        result.ready = true;
                        if ($scope.failedCount == 0) scheduleClose();
                    });
                })(this);
            }

            function _retryRestoreOnConflicted() {
                angular.forEach(multiResults, function (result) {
                    if (result.conflictRestore) result.retryRestore();
                });
            }

            function untranslatedMessage(type, count) {
                return $scope.actionMap[$scope.action][type + 'Message'][pluralizeIndex(count)];
            }

            function succeededCount() {
                return $scope.passedCount - $scope.failedCount;
            }

            function pluralizeIndex(count) {
                return Math.min(2, count) - 1;
            }

            function scheduleClose() {
                $timeout($scope.ok, MODAL_TTL);
            }
        }]);
